<script lang="ts">
    import {Banner, Button, Card, Heading} from "flowbite-svelte";
    import dayjs from "dayjs";
    import {BookSolid, CalendarMonthOutline, PaperPlaneSolid} from "flowbite-svelte-icons";
    import ProjectStatus from "$lib/components/ProjectStatus.svelte";
    import {beforeNavigate, goto} from "$app/navigation";

    export let projects;
    let rerendering = false;

    beforeNavigate(ev => {
        if(ev.to.url.pathname !== '/projects'){
            rerendering = true
        }
    })
    const navigateTo = (project) => {
        goto(`/project/${project.uuid}`)
    }
</script>
<div class="grid md:grid-cols-2 lg:grid-cols-3 gap-3 my-5">
    {#if rerendering}
        <span>navigating...</span>
    {:else}
        {#each projects as project}
            <Card class="relative max-w-full">
                <Heading tag="h5">{project.name}</Heading>
                <div class="grid grid-cols-3 gap-3 my-3">
                    <CalendarMonthOutline class="w-5 h-5" />
                    <p class="col-span-2">
                        {dayjs(project.startsAt.value).format("DD.MM.YYYY")}
                    </p>
                    <BookSolid class="w-5 h-5" />
                    <p class="col-span-2">
                        {project.customer.name}
                    </p>
                    <PaperPlaneSolid class="w-5 h-5" />
                    <p class="col-span-2">
                        <ProjectStatus value={project.status}/>
                    </p>
                </div>
                <div class="h-24"></div>
                <Banner position="absolute" bannerType="bottom" dismissable={false}>
                    <Button on:click={() => navigateTo(project)}>Details</Button>
                </Banner>
            </Card>

        {/each}
    {/if}
</div>
